import { Component, OnDestroy, OnInit } from '@angular/core';
import { CatalogService } from 'src/app/services/api/catalog/catalog.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';

@Component({
  selector: 'app-catalog-load',
  templateUrl: './catalog-load.component.html',
  styleUrls: ['./catalog-load.component.scss']
})
export class CatalogLoadComponent implements OnInit, OnDestroy {

  progress: number;
  fileToUpload: File = null;
  uploading: boolean;

  stateMachineCall: number;
  currentState: string;

  uploadable: boolean;

  constructor(private breadcrumbsService: BreadcrumbsService,
    private catalogService: CatalogService,
    private notificationsService: NotificationsService) {
  }

  ngOnInit() {
    this.uploadable = false;
    this.stateMachineCall = undefined;
    this.uploading = false;
    this.progress = 0;
    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs: [
          { title: 'Administración', url: 'provision/management' },
          { title: 'Catálogo', url: 'provision/management/catalog' },
          { title: 'Carga de catálogo', url: 'provision/management/catalog/load' },
        ]
      });
    this.checkUploadState();
  }

  public checkUploadState() {
    this.catalogService.getJobStatus().subscribe(
      (data) => {
        this.uploadable = true;
        this.currentState = data.resultado;
        this.uploading = false;
      },
      (error) => {
        this.uploadable = false;
        this.currentState = error.error.errorDesc.resultado;
        this.uploading = false;
        this.stateMachineCall = setTimeout(this.checkUploadState.bind(this), 2000) as any;
      },
    );

  }

  public uploadFile() {
    this.uploadable = false;
    if (this.stateMachineCall !== undefined) {
      clearTimeout(this.stateMachineCall);
    }
    this.uploading = true;

    if (!this.fileToUpload) {
      return;
    }

    this.progress = 0;

    this.catalogService.load(this.fileToUpload, (loaded, total) => {
      this.progress = Math.round((loaded * 100) / total);
    }).subscribe(
      (data) => {
        this.progress = 0;
        this.stateMachineCall = setTimeout(this.checkUploadState.bind(this), 2000) as any;
      },
      (error) => {
        this.progress = 0;
        this.notificationsService.showNotification(
          'Ha habido un problema al subir el fichero. Por favor, vuelva a intentarlo',
          NotificationLevel.ERROR);
        this.stateMachineCall = setTimeout(this.checkUploadState.bind(this), 2000) as any;
      });
  }
  public handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  ngOnDestroy() {
    if (this.stateMachineCall !== undefined) {
      clearTimeout(this.stateMachineCall);
    }
  }

}

